import React, { useEffect, useRef, useState } from "react";
import { test } from "utils/helpers";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";

/* import {
  selectRemoteStethoscope,
  unselectRemoteStethoscope,
} from "../../actions/creators"; */
import "./ParticipantListMenuItem.scss";

const CCModerationParticipantListMenuItem = ({ participant }) => {
  const { t } = useTranslation();
  const [currentValue, setCurrentValue] = useState("");
  const ccModerationParticipants = useSelector(
    (state) => state.ccModeration?.ccModerationParticipants
  );
  const remoteParticipant = useRef(null);
  const getScipId = (id) =>
    id?.substring?.(id.indexOf(":") + 1, id.indexOf(";"));

  const triggerCustomEvent = (eventName, data) => {
    const event = new CustomEvent(eventName, { detail: data });
    document.dispatchEvent(event);
  };

  useEffect(() => {
    remoteParticipant.current = ccModerationParticipants.find(
      (ccParticipant) =>
        ccParticipant.particpantId === getScipId(participant.id)
    );
    if (remoteParticipant.current) {
      setCurrentValue(remoteParticipant.current.currentValue);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [ccModerationParticipants]);

  if (
    !remoteParticipant.current ||
    (currentValue !== "on" && currentValue !== "off") || (!remoteParticipant.current.isEnable)
  ) {
    return null;
  }

  return (
    <li
      className="participant-nav__list-item"
      onClick={() => {
        if (currentValue === "off") {
          setCurrentValue("on");
        } else {
          setCurrentValue("off");
        }
        triggerCustomEvent("ccModerationClicked",{detail:remoteParticipant.current});
      }}
      {...test("CCMODERATION")}
    >
      <span
        className={
          currentValue === "on"
            ? "participant-nav__icon participant-nav__icon--cc-moderation active"
            : "participant-nav__icon participant-nav__icon--cc-moderation"
        }
      ></span>
      <span className="participant-nav__title">
        {currentValue === "on" ? t("DISABLE_CC") : t("ENABLE_CC")}
      </span>
    </li>
  );
};

export default CCModerationParticipantListMenuItem;
